const DEFAULT_APP_NAMES = {
  'zh-CN': '企业数智化转型顾问作战系统',
  'zh-TW': '企業數智化轉型顧問作戰系統',
  'en-US': 'Consultant Operations System',
  'ja-JP': '企業デジタル変革コンサルタント作戦システム',
} as const;

const DEFAULT_CRM_API_URL = 'https://crm.zhiyueyun.com';

export type ExternalServiceConfig = {
  baseUrl?: string;
  basePath?: string;
  timeout?: number;
};

export type BizAppServices = {
  main: ExternalServiceConfig;
  crm: ExternalServiceConfig;
  task: ExternalServiceConfig;
};

const services: BizAppServices = {
  main: {
    baseUrl: process.env.UMI_APP_API_URL,
    basePath: '',
  },
  crm: {
    baseUrl: process.env.UMI_APP_CRM_API_URL || DEFAULT_CRM_API_URL,
    basePath: '',
  },
  task: {
    baseUrl: process.env.UMI_APP_TASK_API_URL,
    basePath: '',
  },
};

export const BizAppConfig = {
  // 应用名称
  appName: process.env.UMI_APP_APP_NAME || DEFAULT_APP_NAMES['zh-CN'],

  // 多语言应用名称
  appNames: {
    'zh-CN': process.env.UMI_APP_APP_NAME_ZH_CN || DEFAULT_APP_NAMES['zh-CN'],
    'zh-TW': process.env.UMI_APP_APP_NAME_ZH_TW || DEFAULT_APP_NAMES['zh-TW'],
    'en-US': process.env.UMI_APP_APP_NAME_EN_US || DEFAULT_APP_NAMES['en-US'],
    'ja-JP': process.env.UMI_APP_APP_NAME_JA_JP || DEFAULT_APP_NAMES['ja-JP'],
  },

  // 应用 logo
  appLogo: process.env.UMI_APP_APP_LOGO,

  // 底部版权
  appFooterCopyright: process.env.UMI_APP_APP_FOOTER_COPYRIGHT,

  // 多语言底部版权
  appFooterCopyrights: {
    'zh-CN': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_CN,
    'zh-TW': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_ZH_TW,
    'en-US': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_EN_US,
    'ja-JP': process.env.UMI_APP_APP_FOOTER_COPYRIGHT_JA_JP,
  },

  // API 地址（由不同环境配置文件注入 UMI_APP_API_URL）
  appApiUrl: process.env.UMI_APP_API_URL,

  services,

  // ============ 新建应用需要修改！！！ ============
  // SSO 客户端ID（优先读取环境变量，否则用默认值）
  appSsoClientId: process.env.UMI_APP_SSO_CLIENT_ID,

  // SSO 授权地址
  appSsoAuthorizeUrl: process.env.UMI_APP_SSO_AUTHORIZE_URL,

  // SSO 登出地址
  appSsoLogoutUrl: process.env.UMI_APP_SSO_LOGOUT_URL,

  // 个人中心地址
  appPersonalCenterUrl: process.env.UMI_APP_PERSONAL_CENTER_URL,

  // 企业管理地址
  // 支持占位符：{tenantUuid}、{organizationUuid}
  appTenantManagementUrl: process.env.UMI_APP_TENANT_MANAGEMENT_URL,

  // 工作台地址
  appWorkbenchUrl: process.env.UMI_APP_WORKBENCH_URL,
};

export type BizAppServiceKey = keyof typeof BizAppConfig.services;
